import omniShareOfShelfShardsService from 'src/store/modules/omni/omniShareOfShelfShardsService/reducers';
import * as omniShareOfShelfShardsServiceOperation from 'src/store/modules/omni/omniShareOfShelfShardsService/operations';

export { omniShareOfShelfShardsServiceOperation };
export default omniShareOfShelfShardsService;
